export const NoImagesDialogEnum = Object.freeze({
  TITLE: 'No Images Found',
  BODY: 'Click the button below to upload images',
  UPLOAD_BUTTON: 'Add Images',
});
